import { useSyncExternalStore } from 'react';
import { engine, type EngineState } from '../lib/engine.ts';

export function useEngine(): EngineState {
  return useSyncExternalStore(engine.subscribe, engine.getSnapshot, engine.getSnapshot);
}

export { engine };
